import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const files = require.context('@/modules', true, /module.js$/)
let clientModules = {}
files.keys().forEach(key => {
  clientModules = { ...clientModules, ...files(key).modules }
})
export default new Vuex.Store({
  modules: {
    ...clientModules
  }
})
